import React, {useState} from 'react';
import Box from "@mui/material/Box";
import {Typography} from "@mui/material";
import Button from "@mui/material/Button";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import {FormGrid} from "../../checkout/components/billingData/DataForm";

function ProductPromoEditor({obj, onChange}) {
    const [name, setName] = useState('');
    const [value, setValue] = useState('');

    const addNewValue = () => {
        if (name.trim() && value.trim()) {
            const newObj = Object.assign({}, obj);
            newObj[name.trim()] = value.trim();
            onChange(newObj);
            setName('');
            setValue('');
        }
    }

    const onDelete = (key) => {
        const newObj = Object.assign({}, obj);
        delete newObj[key];
        onChange(newObj);
    }

    const onEdit = (key) => {
        setName(key);
        setValue(obj[key]);
    }

    return (
        <div className="promoeditor">
            {Object.keys(obj || {}).map(key => <Box sx={{display: 'flex'}}>
                <Typography>
                    {key}:
                </Typography>
                <Typography>
                    {obj[key]}
                </Typography>
                <Button onClick={() => onDelete(key)}>Delete</Button>
                <Button onClick={() => onEdit(key)}>Edit</Button>
            </Box>)}
            <FormGrid size={{xs: 12}}>
                <FormLabel htmlFor="name" required>
                    Name:
                </FormLabel>
                <TextField
                    id="name"
                    name="name"
                    type="text"
                    placeholder={"Name"}
                    required
                    size="small"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                />
            </FormGrid>
            <FormGrid size={{xs: 12}}>
                <FormLabel htmlFor="value" required>
                    Value:
                </FormLabel>
                <TextField
                    id="value"
                    name="value"
                    type="number"
                    placeholder={"Value"}
                    required
                    size="small"
                    value={value}
                    onChange={(event) => setValue(event.target.value)}
                />
            </FormGrid>
            <Button onClick={addNewValue}>Add</Button>
        </div>
    );
}

export default ProductPromoEditor;
